// pages.
import { Navigate } from 'react-router-dom';
import { LoginPage, LoginPageSSO, LoginPageLaunch, LaunchPage } from '@pages';
import { HomePage } from '@pages/HomePage/HomePage';
import { PolygonsPage } from '@pages/PolygonPage';
import { PolygonViewerPage } from '@pages/PolygonViewer';
import { DocumentAuditsPage } from '@pages/DocumentAuditPage';
import { AlgorithmicTradingPage } from '@pages/AlgorithmicTradingPage';

// routes.
import { routesPolygonsPage } from '@pages/PolygonPage/routes/routes';
import { routesPolygonViewerPages } from '@pages/PolygonViewer/routes/routes';
import { routesDocumentAuditPage } from '@pages/DocumentAuditPage/routes/routes';
import { routesOrchestratorPricingCommitteePage } from '@pages/OrchestratorPricingCommitteePage/routes/routes';
import { OrchestratorPricingCommitteePage } from '@pages/OrchestratorPricingCommitteePage';

// interfaces.
export interface IRoute {
  id: string;
  path: string;
  element: JSX.Element;
  children?: IRoute[];
  protected?: boolean;
}

export const routes: IRoute[] = [
  {
    id: 'root',
    path: '/',
    element: <Navigate to="/launch-login" replace />,
    protected: false,
  },
  {
    id: 'login',
    path: '/login',
    element: <LoginPage />,
    protected: false,
  },
  {
    id: 'login-sso',
    path: '/login-sso',
    element: <LoginPageSSO />,
    protected: false,
  },
  // ── SSO Launcher (prueba independiente — no afecta el flujo existente) ──
  {
    id: 'launch-login',
    path: '/launch-login',
    element: <LoginPageLaunch />,
    protected: false,
  },
  {
    id: 'launch',
    path: '/launch',
    element: <LaunchPage />,
    protected: false, // La guarda propia LaunchPage (redirige si no hay auth)
  },
  {
    id: 'home',
    path: 'home',
    element: <HomePage />,
    children: [],
    protected: true,
  },
  {
    children: routesPolygonsPage,
    id: 'polygons',
    path: 'polygons',
    element: <PolygonsPage />,
    protected: true,
  },
  {
    children: routesPolygonViewerPages,
    id: 'polygon-viewer',
    path: 'polygon-viewer',
    element: <PolygonViewerPage />,
    protected: true,
  },
  {
    children: routesDocumentAuditPage,
    id: 'document-audit',
    path: 'document-audit',
    element: <DocumentAuditsPage />,
    protected: true,
  },
  {
    children: routesOrchestratorPricingCommitteePage,
    id: 'orchestrator-pricing-committee',
    path: 'orchestrator-pricing-committee',
    element: <OrchestratorPricingCommitteePage />,
    protected: true,
  },
  {
    id: 'algorithmic-trading',
    path: 'algorithmic-trading',
    element: <AlgorithmicTradingPage />,
    children: [
      { id: 'at-hesh',               path: 'hesh',               element: <AlgorithmicTradingPage /> },
      { id: 'at-pricing-committee',  path: 'pricing-committee',  element: <AlgorithmicTradingPage /> },
    ],
    protected: true,
  },
];
